export const ROLES = {
  FARMER: "farmer",
  DRIVER: "driver",
};
